import { render } from "./Bulkupload.vue?vue&type=template&id=0bc9a810&scoped=true"
import script from "./Bulkupload.vue?vue&type=script&lang=js"
export * from "./Bulkupload.vue?vue&type=script&lang=js"

import "./Bulkupload.vue?vue&type=style&index=0&id=0bc9a810&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc9a810"]])

export default __exports__